<template>
  <div>
    <span class="jr_regist_confirm_message"
      >※内容を確認し、送信をクリックしてください。修正がある場合は、戻るをクリックして修正してください。</span
    >
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/**
 * 確認メッセージコンポーネント(仮申請(確認)・本申請(確認))
 */
export default defineComponent({
  name: 'JrRegistConfirmMessage',
})
</script>
